import React, {useState , useEffect} from 'react';
import { Col, Container, Row , Input} from 'reactstrap';
import Create_New_Dashboard from '../../Components/Common/CustomModal/Create_New_Dashboard';
import ChartListView from './ChartListView';
import ChartGridView from './ChartGridView';
import Dashboard_Chart_Pagination from './Dashboard_Chart_Pagination';
import { useDispatch , useSelector } from 'react-redux';
import { Get_Create_Bot_Group_List } from '../../slices/thunks';
import { DELETE_DASHBOARD, FETCH_DASHBOARD_LIST, GET_DASHBOARD_CATEGORY } from '../../slices/dashboard/thunk';
import config from '../../config';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../utility/wait_for_confirmation';
import Loader from '../../Components/Common/Loader';
import { set_bread_crum } from '../../slices/header/reducer';
import { useNavigate } from 'react-router-dom';
import { reset_dashboard_reducer } from '../../slices/dashboard/reducer';

const DashboardChart = () => {
const [activeView, setActiveView] = useState("grid");
const [isActive, setIsActive] = useState(false);
const [filter, setfilter] = useState({
  page: 1,
  per_page: config.general_config.PER_PAGE_CONTENT,
  sort_by:null,
  sort_order:null,
  search_dashboard_id:null,
  search_group_id:null,
  search_group_name:null,
  search_dashboard_category:null,
  search_dashboard_title:null,
  search_dashboard_description:null,
  search_last_updated_date:null,
  sort_by_latest_use:1
  })
const dispatch = useDispatch()
const navigate = useNavigate()
const {  Group_List   }  = useSelector((state)=>state.Create_Bot)

const {  dashboard_loader , dashboard_list , dashboard_category  , dashboard_list_loader  }  = useSelector((state)=>state.Dashboard)




// // Function to toggle the class
// const toggleClass = () => {
// setIsActive(!isActive);
// };


     // The Groups and category are fetched here  . 
       useEffect(() => {
         
       dispatch(Get_Create_Bot_Group_List())
       dispatch(FETCH_DASHBOARD_LIST(filter))
       dispatch(reset_dashboard_reducer())
       dispatch(GET_DASHBOARD_CATEGORY())
      
       }, [])


const onChange_sort_by_group = (e) => {
    let filter_temp = filter
    if (e.target.value === " "){
     
      filter_temp.search_group_id = null;
 
      
    }
    else{
    
     
     filter_temp.search_group_id = e.target.value;

  
    }

    filter_temp.page=1
    setfilter(filter_temp)
 
      // Get the Dashboard list according to the filter .
      dispatch(FETCH_DASHBOARD_LIST(filter_temp))
  }


   const onChange_sort_by_last_use = (e) => {
      let filter_temp = filter
      if (e.target.value === " "){
       
        filter_temp.sort_by_latest_use = 0;
   
        
      }
      else{
      
       
       filter_temp.sort_by_latest_use = e.target.value;
  
    
      }
  
      filter_temp.page=1
      setfilter(filter_temp)
   
     ///

     dispatch(FETCH_DASHBOARD_LIST(filter_temp))
    }


    const onChange_sort_by_search_titles = (e) => {
        let filter_temp = filter
        if (e.target.value === " "){
         
          filter_temp.search_dashboard_title = null;
     
          
        }
        else{
        
         
         filter_temp.search_dashboard_title = e.target.value;
    
      
        }
    
        filter_temp.page=1
        setfilter(filter_temp)

        dispatch(FETCH_DASHBOARD_LIST(filter_temp))
     
        //
      }


    const onChange_sort_by_category = (e) => {
    let filter_temp = filter
    if (e.target.value === " "){
     
      filter_temp.search_dashboard_category = null;
 
      
    }
    else{
    
     
     filter_temp.search_dashboard_category = e.target.value;

  
    }

    filter_temp.page=1
    setfilter(filter_temp)
 
      // Get the Dashboard list according to the filter .
      dispatch(FETCH_DASHBOARD_LIST(filter_temp))
  }

const delete_dashboard = async ({ dashboard_id })=>{
    dispatch(open_confirm_modal("Do you want to delete the Dashboard ."))
    confirm =  await waitForDecision()
    if(confirm){
       dispatch(DELETE_DASHBOARD({filterData:filter , dashboard_Id:dashboard_id}))
    }

    dispatch(close_confirm_modal())
}


const handleViewDashboard = ({Dashboard_Id})=>{
  navigate('/Dashboard_st', {
            state: { Dashboard_Id: Dashboard_Id }
        })
}
  

  const onPageChange = (page_number) => {
    let filter_temp = filter
    filter_temp.page=Number.parseInt(page_number)
    setfilter(filter_temp)
  dispatch(FETCH_DASHBOARD_LIST(filter_temp))
     
  }
  
       

const handleButtonClick = (view) => {
    setActiveView(view);
    };

     useEffect(()=>{
        dispatch(set_bread_crum({ title:"Chart Dashboard"  , pageTitle:"Dashboard"  }))
    
        return ()=>{
        dispatch(set_bread_crum({ title:""  , pageTitle:""  }))
            
        }
      },[])
  return (
    <>
        <React.Fragment>
            <div className="page-content pt-10 chartdashboard">  
               <Container fluid>
                 <Row>
                    <Col xl={3}>
                        <div className="wrap_bot_buttons d-flex justify-content-between align-items-center mb-3">
                            <div className="switch_view ">                
                                <button
                                className={`btn ${activeView === "grid" ? "Active" : ""}`}
                                onClick={() => handleButtonClick("grid")}
                            >
                                <i className="mdi mdi-apps"></i>
                            </button>
                                <button
                                className={`btn ${activeView === "list" ? "Active" : ""}`}
                                onClick={() => handleButtonClick("list")}
                            >
                                <i className="mdi mdi-format-align-justify" />
                            </button>
                            </div>
                            {/* <div className="sfs">
                                <button onClick={toggleClass}>
                                    <i className="mdi mdi-format-align-justify" />
                                </button>
                            </div> */}
                        </div>
                    </Col>
                    <Col xl={9} className={isActive ? 'active-div' : 'dactive-div'}>
                <div className="filter_or_sort mb-3">
                    
                    <div className="input-group">
                        <Input onChange={onChange_sort_by_search_titles} type="text" className="form-control h-40" placeholder="Search Bot name" aria-label="Recipient's username with two button addons" />
                        <button className="btn btn-secondary padd_10" type="button"><i className="bx bx-search fs-20" /></button>
                    </div>
                      <div>
                      <select onChange={onChange_sort_by_group} className="form-select" aria-label="Default select example">
                            <option value={" "}>Filter by group</option>
                            {
                              Group_List.map((ele, i)=>{
                                   return <option key={i} value={ele.Group_ID}>{ele.Group_Name}</option>
                              })
                            }
                           
                        </select>
                        </div>
                        <div>
                        <select  onChange={onChange_sort_by_category} className="form-select" aria-label="Default select example">
                            <option value={""} >Filter by category                             
                            </option>
                            {
                              dashboard_category.map((ele, i)=>{
                                   return <option key={i} value={ele.Dashboard_Category}>{ele.Dashboard_Category}</option>
                              })
                            }
                        </select>
                        </div>
                        <div>
                        <select onChange={onChange_sort_by_last_use} className="form-select" aria-label="Default select example">
                            <option value={1} >Sort by latest use                            
                            </option>
                            <option value={0} >Sort by oldest use                            
                            </option>
                        </select>
                        </div>
                        <div className="d-grid gap-2">
                            <Create_New_Dashboard />
                        </div>                        
                    
                </div>
            </Col>
                    
                 </Row>
                 {dashboard_list_loader ? <Loader/> : <Row>
                    <Col>
                        {activeView === "list" ? (
                          <>
                          
                          <ChartListView delete_dashboard={delete_dashboard} handleViewDashboard={handleViewDashboard} />
                            
                          </>
                        ) : (
                          <>
                      
                          <ChartGridView delete_dashboard={delete_dashboard} handleViewDashboard={handleViewDashboard}  />
                        
                          </>
                        )}
                    </Col>
                 </Row>}
                 <Row>
                    <Col>
                    <Dashboard_Chart_Pagination onPageChange={onPageChange} total_pages={dashboard_list.total_pages} current_page={dashboard_list.current_page} />
                    </Col>
                 </Row>
               </Container>
            </div>
        </React.Fragment>    
    </>
  )
}

export default DashboardChart